import {
  Box,
  Grid,
  makeStyles,
  Paper,
  Theme,
  Typography,
} from '@material-ui/core';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { MedisanteDevice } from '../../types';

const useStyles = makeStyles((theme: Theme) => ({
  device: {
    margin: theme.spacing(0, 0, 1, 0),
    padding: theme.spacing(1),
    userSelect: 'none',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    minHeight: 100,
    flexShrink: 0,
  },
  fvb: {
    display: 'flex',
    flex: '0 0 40%',
    marginRight: '5%',
    whiteSpace: 'nowrap',
    marginTop: theme.spacing(0.5),
    alignItems: 'center',
  },
  field: {
    display: 'inline-block',
    backgroundColor: theme.palette.action.hover,
    minWidth: '50px',
    margin: theme.spacing(0, 1, 0, 0),
    padding: theme.spacing(0.5, 1),
    borderRadius: theme.shape.borderRadius,
    textAlign: 'left',
  },
  value: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  valueLong: {
    minWidth: '220px',
  },
  valueShort: {
    minWidth: '100px',
  },
}));

interface Props {
  device: MedisanteDevice;
  totalView: boolean;
}

function DeviceBox(props: Props) {
  const { device, totalView } = props;
  const classes = useStyles();
  const history = useHistory();
  return (
    <Paper
      className={classes.device}
      key={device.id}
      onClick={() => {
        history.push(`/devices/${encodeURIComponent(device.id)}`);
      }}
    >
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={4}>
          <Typography variant="h6">{device.model}</Typography>
        </Grid>
      </Grid>

      <Box display="flex" flexWrap="wrap" alignContent="flex-end">
        <div className={classes.fvb}>
          <label className={classes.field}>SN</label>
          <span className={`${classes.value} ${classes.valueLong}`}>
            {device.serialNumber}
          </span>
        </div>
        <div className={classes.fvb}>
          <label className={classes.field}>Measurements</label>
          <div className={`${classes.value} ${classes.valueShort}`}>
            {totalView ? device.measurementCount : device.measurementTripCount}
          </div>
        </div>
        <div className={classes.fvb}>
          <label
            htmlFor={`${device.id}-MAC`}
            className={classes.field}
            id={`mac-${device.id}-label`}
          >
            MAC Address
          </label>
          <span
            id={`${device.id}-MAC`}
            className={`${classes.value} ${classes.valueShort}`}
            aria-labelledby={`mac-${device.id}-label`}
          >
            {device.mac || '-'}
          </span>
        </div>
      </Box>
    </Paper>
  );
}

export default DeviceBox;
